/* eslint-disable no-param-reassign */

import PictureTooltip from 'client/shared/picture_tooltip';
import { logError } from 'client/javascript/util/logger';
import { renderNecessaryModulesBasedOnUserGeolocation } from 'client/javascript/pages/shared/location_based_override_module';

const isTooltipNotInitialized = tooltip => tooltip.style.left === '';

const SELECTORS = {
  TABLE_TOOLTIPS: '.compare-module .tooltip-box--information-icon',
  PRICING_COLUMNS: '.compare-module__table-pricing td',
  PRICE_VALUES: '.pricing-value',
  FOOTER_CONDITIONAL_BTN: '.js-footer-optional-btn'
};

const NON_PRICE_VALUE_MODIFIER_CLASS = 'pricing-value--no-price';

export class CompareModule {
  constructor(solutionsApiData, countryCode) {
    this.solutionsApiData = solutionsApiData;
    this.tableTooltips = Array.from(document.querySelectorAll(SELECTORS.TABLE_TOOLTIPS));
    this.solutionsPricing = document.querySelectorAll(SELECTORS.PRICING_COLUMNS);

    this.initializeTableTooltips();
    renderNecessaryModulesBasedOnUserGeolocation({
      countryCode,
      selector: SELECTORS.FOOTER_CONDITIONAL_BTN,
      locationAttributeName: 'conditionsToShowLink'
    });
  }

  initializeTableTooltips() {
    if (this.tableTooltips.some(isTooltipNotInitialized)) {
      PictureTooltip.setUp();
    }
  }

  // TODO: refactor when "Product Catalog Pricing" is added
  setPricing(solutionsDetails) {
    if (solutionsDetails == null) {
      return this.solutionsPricing.forEach(column => {
        const solutionPricingValues = column.querySelectorAll(SELECTORS.PRICE_VALUES);
        solutionPricingValues.forEach(solutionPrice => {
          solutionPrice.classList.toggle(NON_PRICE_VALUE_MODIFIER_CLASS);
          solutionPrice.innerHTML = '-';
        });
      });
    }

    this.solutionsPricing.forEach((column, columnIndex) => {
      const solutionsColumnApiData = this.solutionsApiData[columnIndex];
      const solutionPricingValues = column.querySelectorAll(SELECTORS.PRICE_VALUES);

      solutionPricingValues.forEach((solutionPrice, priceIndex) => {
        const solutionApiData = solutionsColumnApiData[priceIndex];

        if (solutionApiData.apiSystemName == null) {
          // skip current price as pricing from API is not needed
          return null;
        }

        const solutionPricing = solutionsDetails[solutionApiData.name];

        if (solutionPricing == null) {
          // skip current price as pricing cannot be set from API
          return null;
        }

        solutionPrice.innerHTML = solutionPricing.minPrice;
      });
    });
  }

  static create(...args) {
    try {
      return new CompareModule(...args);
    } catch (error) {
      logError(`[Shared modules] CompareModule class creation failed: ${error.message}`, error);
    }
  }
}
